import React from 'react';
import { ProjectContext } from '../../types/Project';
import ProjectDetailsContext from './ProjectContext';

type ProjectDetailsProviderOptions = {
  /**
   * The child nodes the Provider has wrapped
   */
  children?: React.ReactNode;
  /**
   * The project details data to provide to consumers.
   */
  value: ProjectContext;
};

const ProjectDetailsProvider = (opts: ProjectDetailsProviderOptions) => {
  const { value, children } = opts;

  return <ProjectDetailsContext.Provider value={value}>{children}</ProjectDetailsContext.Provider>;
};

export default ProjectDetailsProvider;
